import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.admin/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public category: string = '';
    public main: string = '';
    public sub: string = '';
    public id: string = '';
    public menu: string = '';

    private routerSub: any;
    private routeSub: any;
    private initialized: boolean = false;

    public categories: any[] = [
        {
            key: 'invest',
            title: '투자관리',
            description: '조합 결성·운용·해산, 투자기업, 조합원 관리',
            icon: 'chart',
            color: 'blue'
        },
        {
            key: 'support',
            title: '지원사업',
            description: '지원사업 관리 및 운영',
            icon: 'clipboard',
            color: 'emerald'
        },
        {
            key: 'tips',
            title: '팁스',
            description: '팁스 추천·선정·졸업 기업 관리',
            icon: 'building',
            color: 'amber'
        },
        {
            key: 'lips',
            title: '립스',
            description: '립스 추천·선정·졸업 기업 관리',
            icon: 'sparkles',
            color: 'cyan'
        },
        {
            key: 'system',
            title: '관리시스템',
            description: '내부 결재 및 시스템 관리',
            icon: 'cog',
            color: 'violet'
        },
        {
            key: 'collab',
            title: '협업툴',
            description: '프로젝트·업무·메신저·캘린더 통합 협업',
            icon: 'users',
            color: 'rose'
        }
    ];

    public async ngOnInit() {
        // The admin page is reused while moving between list/detail URLs.
        // Subscribe to route params directly so structural *ngIf blocks are
        // updated even when a NavigationEnd callback is missed or delayed.
        this.routeSub = this.route.params.subscribe(async (params) => {
            this.updateSegments(params);
            if (!this.initialized) return;
            if (!this.canAccessCurrentRoute()) {
                await this.service.href("/");
                return;
            }
            await this.service.render();
        });

        // 초기 직접 접근의 NavigationEnd도 놓치지 않도록 인증 초기화 전에 구독한다.
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updateSegments(this.route.snapshot.params || {});
                if (!this.initialized) return;
                if (!this.canAccessCurrentRoute()) {
                    await this.service.href("/");
                    return;
                }
                await this.service.render();
            }
        });

        // 라우터 이벤트가 이미 종료된 초기 접근을 위해 즉시 반영한다.
        this.updateSegments();
        await this.service.init();
        this.initialized = true;
        this.updateSegments();
        if (!this.canAccessCurrentRoute()) {
            await this.service.loading.hide();
            await this.service.href("/");
            return;
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.routeSub) this.routeSub.unsubscribe();
    }

    private updateSegments(routeParams: any = null) {
        const snapshot = routeParams || this.route.snapshot.params || {};
        const path = this.router.url.split(/[?#]/)[0];
        const parts = path.split('/').filter((item: string) => item.length > 0);
        const direct = parts[0] === 'admin' ? {
            category: parts[1],
            main: parts[2],
            sub: parts[3],
            id: parts[4],
            menu: parts[5]
        } : {};
        const legacy = WizRoute.segment || {};

        // The browser URL is authoritative. ActivatedRoute snapshots can still
        // contain the previous optional segment while Angular reuses this page.
        this.category = direct.category || snapshot.category || legacy.category || '';
        this.main = direct.main || snapshot.main || legacy.main || '';
        this.sub = direct.sub || snapshot.sub || legacy.sub || '';
        this.id = direct.id || snapshot.id || legacy.id || '';
        this.menu = direct.menu || snapshot.menu || legacy.menu || '';

        if (!this.category) {
            // 리다이렉트와 동시에 로컬 상태도 즉시 기본값으로 설정 —
            // NavigationEnd가 늦게 도착하거나 누락되더라도 *ngIf가 즉시 평가되어
            // 대시보드가 첫 진입 시에도 바로 마운트되도록 보장
            this.category = 'invest';
            this.main = 'dashboard';
            this.service.href('/admin/invest/dashboard');
            return;
        }

        if (this.category && !this.main) {
            this.main = 'dashboard';
            this.service.href(`/admin/${this.category}/dashboard`);
            return;
        }

        if (this.category === 'system' && !this.isSuperAdmin()) {
            const personalRoutes: any = {
                'hr-records': 'my-hr-records',
                attendance: 'my-attendance',
                leave: 'my-leave',
            };
            if (personalRoutes[this.main]) {
                this.main = personalRoutes[this.main];
                this.service.href(`/admin/system/${this.main}`);
            }
        }

        if (this.category === 'invest' && this.main === 'compliance-module' && !this.isSuperAdmin()) {
            this.main = 'dashboard';
            this.service.href('/admin/invest/dashboard');
            return;
        }
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public isAdminUser(): boolean {
        return ['admin', 'super_admin'].includes(this.service.auth?.session?.membership);
    }

    public isComplianceOfficer(): boolean {
        const extra = this.service.auth?.session?.extra || {};
        return !!extra.is_compliance_officer;
    }

    public isComplianceChecklistRoute(): boolean {
        const allowedCompanyRoutes = ['company', 'meeting_company', 'review_company', 'exit_company', 'dropped_company'];
        return this.category === 'invest'
            && allowedCompanyRoutes.includes(this.main)
            && !!this.sub
            && this.id === 'investment'
            && this.menu === 'compliance';
    }

    public canAccessCurrentRoute(): boolean {
        return this.isAdminUser() || (this.isComplianceOfficer() && this.isComplianceChecklistRoute());
    }

    public visibleCategories(): any[] {
        if (this.isAdminUser()) return this.categories;
        return this.categories.filter((cat: any) => cat.key === 'invest');
    }

    public event: any = {
        fund_item: {
            update: async (code, data) => {
                if (code == 201) {
                    location.href = `/admin/invest/fund/${this.sub}/${data}`;
                    return;
                } else if (code == 200) {
                    this.service.alert.success("저장되었습니다.");
                } else {
                    this.service.alert.error("오류가 발생했습니다.");
                }
            }
        }
    }
}

export default PageAdminComponent;